const WEBAPP_URL = 'https://script.google.com/macros/s/AKfycbyv3-HGpVwleNm-UOJYj0yU28KaBtGHwC5uUFHxnzqwf8ofd9nbXsx_ZMTaKhpPT1Rc/exec';

window.go404 = async function go404() {
    return window.location.replace('/404');
}

window.writeEnquiries = async function writeEnquiries (payload) {     
    const res = await fetch(WEBAPP_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const data = await res.json();

    if (!data.ok || !data.id || !data.key) {
        throw new Error('Server rejected payload');
    }

    return { id: data.id, key: data.key };
};

window.readEnquiries = async function readEnquiries(key, secret) {
    const id = secret;

    const url =
    `${WEBAPP_URL}?id=${encodeURIComponent(id)}` +
    `&key=${encodeURIComponent(key)}` +
    `&t=${Date.now()}`;

    const res = await fetch(url, { method: 'GET', credentials: 'omit' });

    const data = await res.json().catch(() => null);
    if (!data || !data.ok) return null;

    return data.payload || null;
};